// extracted by mini-css-extract-plugin
module.exports = {"DateFields":"ManualEntryFormV2_DateFields__SolKD","PrecisionLabel":"ManualEntryFormV2_PrecisionLabel__tBUYm"};